import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

/**
 * data = [{ name, stock }]
 */
const LowStockChart = ({ data = [], loading }) => {
  const chartData = (data || [])
    .filter((m) => m.stock <= m.lowStockLimit) // Only low stock
    .map((m) => ({
      name: m.name,
      stock: m.stock,
    }));

  if (loading) return <p>Loading...</p>;
  if (!chartData.length) return <p>No low stock medicines 🎉</p>;

  return (
    <div style={{ width: "100%", height: 260 }}>
      <ResponsiveContainer>
        <BarChart data={chartData}>
          <XAxis dataKey="name" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Bar dataKey="stock" fill="#dc3545" /> {/* Red bar for low stock */}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LowStockChart;
